// /en/ ayna URL ağacı — tek kaynak.
// Bare URL her zaman Türkçe, /en/ altındaki ayna her zaman İngilizce içerik sunar.
// Bireysel sayfaların İngilizce slug'ları SEO brief'inden; diğer sayfalar /en öneki alır.

const EN_SLUGS = {
  "/bireysel": "/en/personal",
  "/ucretsiz-butce-uygulamasi": "/en/free-budget-app",
  "/gelir-gider-takibi": "/en/income-expense-tracking",
  "/ev-yonetimi": "/en/household-management",
  "/doviz-altin-takibi": "/en/gold-currency-tracking",
  "/fis-okuma": "/en/receipt-scanner",
  "/rehber": "/en/guides",
};

const TR_SLUGS = Object.fromEntries(Object.entries(EN_SLUGS).map(([tr, en]) => [en, tr]));

export const isEnPath = (path) => path === "/en" || path.startsWith("/en/");

export const toEnPath = (path) => {
  if (isEnPath(path)) return path;
  if (EN_SLUGS[path]) return EN_SLUGS[path];
  return path === "/" ? "/en" : `/en${path}`;
};

export const toTrPath = (path) => {
  if (!isEnPath(path)) return path;
  if (TR_SLUGS[path]) return TR_SLUGS[path];
  return path === "/en" ? "/" : path.replace(/^\/en/, "");
};

// Bireysel sayfa slug'ından her iki dilde URL üret (BireyselPage spoke linkleri için)
export const bireyselEnPath = (trPath) => toEnPath(trPath);
